<template>
  <div
    class="mobile-container-box"
    :class="$route.meta.showBtomPad ? 'btom-pad' : ''"
  >
    <!-- 手机端布局 -->
    <div
      class="top-nav-box common-flex-box"
      ref="topBox"
      v-if="!$route.meta.hideHeader"
    >
      <div
        v-if="$route.path !== '/artwork-list' && $route.path !== '/artist-list' && $route.path !== '/photo-list'"
      >
        <!-- 繁->En->简 -->
        <div
          v-for="(item, index) in langImg"
          :key="index"
          v-if="$store.state.AcceptLanguage == item.ID"
          class="language-select"
          @click="changeLang(item)"
        >
          <img :src="item.img" />
        </div>
      </div>
      <div class="logo-box text-center">
        <div class="box clearfix">
          <!-- class="f-l" -->
          <img src="https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/logo.png" alt="" />
          <!-- f-l -->
          <!-- <div class="text text-left">
            <div class="name">{{ $t("LastTranslate.Name1") }}</div>
            <div class="text-light-gray desc">
              {{ $t("LastTranslate.Name2") }}
            </div>
          </div> -->
        </div>
      </div>
      <div class="search-box" v-if="showSearch == 0 || showSearch == 1">
        <van-field
          v-model="keyword"
          :placeholder="
            showSearch == 0
              ? $t('ArtworkDetail.EnterName')
              : showSearch == 1
              ? $t('ArtworkDetail.EnterArtName')
              : ''
          "
          left-icon="iconsousuo1"
          @keyup.enter="search"
        />
      </div>
      <div class="search-box" v-if="showSearch == 2">
        <div class="banner-category">
          <van-dropdown-menu class="">
            <van-dropdown-item @change="handleChange" v-model="classifyId" :options="option1" />
            <!-- <van-dropdown-item v-model="classifyId" title="" ref="navsPhoto">
              <div
                class="nav-item"
                @click="handleChoose(item)"
                v-for="(item, i) in photoCategory"
                :key="i"
              >
                {{ filterName(item) }}
              </div>
            </van-dropdown-item> -->
          </van-dropdown-menu>
        </div>
      </div>
      <div class="navs-list-box">
        <van-dropdown-menu class="mobile-navs-box">
          <van-dropdown-item title="" class="navs-list" ref="navsMenu">
            <div
              class="nav-item"
              @click="enter(item.route)"
              v-for="(item, i) in navList"
              :key="i"
            >
              {{ $t(item.name) }}
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
      </div>
    </div>
    <router-view
      ref="languageSwitching"
      :style="`min-height: ${boxHeight}px`"
      :search="keyword"
    ></router-view>
    <div class="footer-msg-box text-center" v-if="!$route.meta.hideFooter">
      <img src="https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/logo.png" alt="" class="logo" />
      <div class="name">{{ $t("LastTranslate.Name1") }}</div>
      <div>{{ $t("LastTranslate.Name2") }}</div>
      <!-- <div class="logo-text">CAAA</div> -->
      <div @click="toDown">
        <img
          src="../../../assets/img/android.png"
          alt=""
          class="type android-img"
        />
        <img src="../../../assets/img/IOS.png" alt="" class="type ios-img" />
      </div>

      <div class="text-left text">{{ $t("IndexAboutUs.Address") }}</div>
      <div class="text-left text">{{ $t("IndexAboutUs.Tel") }}</div>
    </div>
    <div class="copy-right-box text-center" v-if="!$route.meta.hideFooter">
      Copyright © {{ yearTime }} {{ $t("LastTranslate.ICP") }}
    </div>
  </div>
</template>

<script>
import mixinDown from "@/pages/mobile/views/mixin/mixinDown";
export default {
  mixins: [mixinDown],
  data() {
    return {
      // 1:代表英文, 2:代表繁体, 3:代表中文 繁->En->简
      langImg: [
        {
          ID: 1,
          value: "en",
          seleceId: 3,
          seleceVal: "zh-CN",
          img: require("../../../assets/img/zh-cn.png"),
        },
        {
          ID: 2,
          value: "zh-TW",
          seleceId: 1,
          seleceVal: "en",
          img: require("../../../assets/img/en.png"),
        },
        {
          ID: 3,
          value: "zh-CN",
          seleceId: 2,
          seleceVal: "zh-TW",
          img: require("../../../assets/img/zh-tw.png"),
        },
      ],
      navList: [
        {
          name: "IndexNavbar.HomePage",
          route: "/",
        },
        {
          name: "IndexNavbar.Founder",
          route: "/founder",
        },
        {
          name: "IndexNavbar.Artwork",
          route: "/artwork-list",
        },
        {
          name: "IndexNavbar.Artists",
          route: "/artist-list",
        },
        {
          name: "IndexNavbar.PrivateArtSteward",
          route: "/private-art-housekeeper",
        },
        {
          name: "IndexNavbar.BusinessModelCase",
          route: "/business-model-cases",
        },
        {
          name: "IndexNavbar.Photo",
          route: "/photo-list",
        },
        {
          name: "IndexNavbar.LatestNews",
          route: "/latest-news",
        },
        {
          name: "IndexNavbar.AboutUs",
          route: "/about-us",
        },
      ],
      keyword: "",
      searchPlaceholder: [
        this.$t("ArtworkDetail.EnterName"),
        this.$t("ArtworkDetail.EnterArtName"),
      ],
      showSearch: -1,
      boxHeight: 0,
      yearTime: "",
      photoCategory: [],
      classifyId: ''
    };
  },
  computed: {
    filterName () {
      return (item) => {
        const locale = this.$store.state.locale
        const str = locale === 'en' ? item.classifyNameEn : item.classifyNameCn
        return str
      }
    },
    option1 () {
      const locale = this.$store.state.locale
      return this.photoCategory.map(ele => {
        ele.value = ele.classifyId
        ele.text = locale === 'en' ? ele.classifyNameEn : ele.classifyNameCn
        return ele
      })
    }
  },
  methods: {
    handleChange (val) {
      this.$refs.languageSwitching.fetchPhotoList(val);
    },
    // 相册分类
    fetchPhotoCategory() {
      this.$commonPromise("get", this.$Api.photoCategory).then((res) => {
        if (res.code === 200) {
          this.photoCategory = [{
            classifyId: '',
            value: '',
            classifyNameCn: '全部相册',
            classifyNameEn: 'All Albums '
          }, ...res.data];
        }
      });
    },
    handleChoose (item) {
      this.$refs.navsPhoto.toggle();
      this.$refs.languageSwitching.fetchPhotoList(item.classifyId)
    },
    getYear() {
      let date = new Date();
      this.yearTime = date.getFullYear();
    },
    enter(route) {
      this.$router.push({
        path: route,
      });
      this.$refs.navsMenu.toggle();
    },
    search() {
      switch (this.$route.name) {
        case "artwork-list":
          this.$refs.languageSwitching.onRefresh();
          break;
        case "artist-list":
          this.$refs.languageSwitching.changeType();
          break;
      }

      // let url = '/artwork-list';
      // if (this.showSearch === 1) {
      // 	url = '/artist-list'
      // }

      // this.$router.push({
      // 	path: url,
      // 	query: {
      // 		artistName: this.keyword
      // 	}
      // });
    },
    isSearch() {
      const routeName = this.$route.name;
      if (routeName == "artwork-list") {
        this.showSearch = 0;
      } else if (routeName == "artist-list") {
        this.showSearch = 1;
      } else if (routeName == 'photo-list') {
        this.showSearch = 2
        this.fetchPhotoCategory()
      } else {
        this.showSearch = -1;
      }
      if (routeName == "artist-detail") {
        this.boxHeight =
          window.innerHeight -
          (this.$refs.topBox
            ? this.$refs.topBox.clientHeight
            : this.$refs.languageSwitching.$refs.topBox.height);
      } else {
        this.boxHeight = 0;
      }
    },
    changeLang(item) {
      this.$store.dispatch("AcceptLanguage", item.seleceId);
      this.$store.commit("setLang", item.seleceVal);
      this.$i18n.locale = item.seleceVal;
      // if(item.ID === 3) {
      // 	this.$store.commit('checkCountry',3);//3:国内官网
      // }else {
      // 	this.$store.commit('checkCountry',4);//4:海外官网
      // }
      switch (this.$route.name) {
        case "home":
          this.$refs.languageSwitching.homeSwiper();
          this.$refs.languageSwitching.updateVideo();
          this.$refs.languageSwitching.recommendArtworkList();
          this.$refs.languageSwitching.recommendArtistList();
          this.$refs.languageSwitching.informationList();
          break;
        case "artwork-detail":
          this.$refs.languageSwitching.artwork();
          this.$refs.languageSwitching.worksDetails();
          break;
        case "artist-detail":
          this.$refs.languageSwitching.getArtistById();
          // this.$refs.languageSwitching.artworkListByArtistId();
          this.$refs.languageSwitching.openDetail("lange");
          break;
        case "latest-news":
          this.$refs.languageSwitching.onRefresh();
          break;
        case "news-detail":
          this.$refs.languageSwitching.getInformationById();
          break;
      }
    },
  },
  watch: {
    $route() {
      this.isSearch();
    },
  },
  mounted() {
    this.getYear();
    this.isSearch();
    if (!this.$route.query.sourceType) {
      this.$store.commit("SourceType", 0); //Source-Type: 0.国内(港版) 1.海外 ,
    }
  },
};
</script>
<style lang="scss">
.banner-category {
  width: 330px;
  padding-right: 30px;
  .van-dropdown-menu::after {
    border: none;
  }
}
.mobile-container-box {
  .van-dropdown-menu__bar {
    height: 84px;
  }
  .van-dropdown-menu__item {
    width: 0.01px;
  }
}
</style>
<style lang="scss" scoped>
.mobile-container-box {
  // &.fill-box {
  //   height: 100vh;
  //   display: flex;
  //   flex-direction: column;
  // }
  &.btom-pad {
    padding-bottom: 128px;
  }

  .top-nav-box {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 84px;
    .language-select {
      width: 45px;
      height: 45px;
      // margin-top: 16px;
      position: absolute;
      left: 30px;
      top: 50%;
      transform: translateY(-50%);
      touch-action: none;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .logo-box {
      flex: 1;
      // padding: 20px 0;
      // padding-top: 20px;
      .box {
        display: inline-flex;
        zoom: 1;

        img {
          height: 110px;
        }

        .text {
          // padding-left: 21px;

          .name {
            margin-bottom: 10px;
            font-size: 20px;
            font-weight: bold;
          }

          .desc {
            font-size: 14px;
          }
        }
      }
    }

    .navs-list-box {
      position: absolute;
      right: 20px;
      .navs-list {
        .nav-item {
          display: block;
          padding: 33px 38px;
          font-size: 30px;
          border-top: 1px solid #eee;
          box-sizing: border-box;
        }
      }
    }

    .search-box {
      margin-right: 110px;
      border: 1px solid #ddd;
      border-width: 0 1px;
    }
  }

  .nav-item {
    display: block;
    padding: 33px 38px;
    font-size: 30px;
    border-top: 1px solid #eee;
    box-sizing: border-box;
  }

  .footer-msg-box {
    padding: 44px 32px 9px;
    color: $text-light-gray;
    // font-size: 24px;
    background-color: #f5f5f5;

    .logo {
      height: 117px;
    }

    .name {
      margin: 35px 0 15px;
      color: #333;
      font-size: 32px;
      font-weight: bold;
    }

    .type {
      display: block;
      height: 71px;

      &.ios-img {
        margin: 0 auto 63px;
      }

      &.android-img {
        margin: 64px auto 32px;
      }
    }

    .text {
      margin-bottom: 23px;
    }
  }

  .copy-right-box {
    padding: 28px 0;
    color: #9b9d9e;
  }
}
</style>
